/**
 * Converts a string to a URL/CSS-safe slug: lowercases and replaces spaces with hyphens.
 * e.g. "My Morning Jacket" → "my-morning-jacket"
 */
export function slugify(str: string): string {
  return str.toLowerCase().replace(/\s+/g, '-');
}
